var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 524,
    height: 391,
    viewBox: "0 0 524 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.168 59.393C195.168 59.393 209.511 41.5297 211.192 25.085C212.296 14.262 202.628 5.48795 191.91 7.58951C183.924 9.16568 172.891 10.269 164.17 7.27428C148.671 1.86275 142.366 20.5667 142.366 20.5667C142.366 20.5667 123.872 20.9344 124.188 32.3879C124.503 43.7889 129.389 49.8309 129.389 49.8309C129.389 49.8309 120.457 65.8553 130.124 75.0497C139.792 84.244 145.151 93.9112 145.151 93.9112L195.168 59.393Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.168 59.393C195.168 59.393 209.511 41.5297 211.192 25.085C212.296 14.262 202.628 5.48795 191.91 7.58951C183.924 9.16568 172.891 10.269 164.17 7.27427C148.671 1.86275 142.366 20.5667 142.366 20.5667C142.366 20.5667 123.872 20.9344 124.188 32.3879C124.503 43.7889 129.389 49.8309 129.389 49.8309C129.389 49.8309 120.457 65.8553 130.124 75.0497C139.792 84.244 145.151 93.9112 145.151 93.9112L195.168 59.393Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.694 103.999L83.418 117.501V333.962H234.52L232.681 116.818L178.881 103.999H135.694Z",
    fill: "#FF5D0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4387 385.77H234.541V333.967H83.4387V385.77Z",
    fill: "#9F99AA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.561 173.304C245.355 170.645 256.004 155.686 253.345 139.892C250.686 124.097 235.727 113.449 219.932 116.107C204.138 118.766 193.489 133.726 196.148 149.52C198.807 165.315 213.766 175.963 229.561 173.304Z",
    fill: "#FF5D0E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M249.704 130.005L279.388 182.072L228.11 209.55L198.846 157.746L249.704 130.005Z",
    fill: "#FF5D0E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M279.389 182.072L299.985 216.432H233.103L228.111 209.55L279.389 182.072Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M279.389 182.072L299.985 216.432H233.103L228.111 209.55L279.389 182.072Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.635 84.2965L137.376 108.727C135.853 125.067 150.301 138.359 166.43 135.47C180.879 132.895 189.968 118.394 185.975 104.261L179.88 82.7729L139.635 84.2965Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.635 84.2965L137.376 108.727C135.853 125.067 150.301 138.359 166.43 135.47C180.879 132.895 189.968 118.394 185.975 104.261L179.88 82.7729L139.635 84.2965Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195.536 31.7574C195.536 31.7574 215.081 74.8919 195.641 103.105C176.202 131.319 139.582 88.0267 139.582 88.0267C139.582 88.0267 141.894 41.7398 149.512 35.1199C157.078 28.3949 185.291 13.6314 195.536 31.7574Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.215 88.6572C139.215 88.6572 141.894 41.6873 149.513 35.0674C157.078 28.3949 185.344 13.6315 195.537 31.7574C195.537 31.7574 215.081 74.892 195.642 103.105C185.607 117.659 171.001 113.193 159.232 105.417",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.167 33.2811C196.167 33.2811 179.144 42.4754 155.712 37.6944C155.712 37.6944 156.29 57.9745 141.526 65.2774C141.526 65.2774 134.644 60.9167 132.174 54.034C126.763 38.9553 182.927 -2.91831 198.531 21.7225C200.318 24.5071 199.162 29.5508 196.167 33.2811Z",
    fill: "#0A0A0A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.168 33.281C196.168 33.281 179.145 42.4753 155.713 37.6943C155.713 37.6943 156.291 57.9744 141.527 65.2773",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M151.93 60.2863C151.93 60.2863 146.098 47.9922 138.375 55.4002C134.802 58.8152 134.435 63.8064 135.012 68.1672C135.748 73.5787 140.687 77.414 146.151 76.7836L151.195 76.2057L151.93 60.2863Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.93 60.2863C151.93 60.2863 146.098 47.9922 138.375 55.4002C134.802 58.8152 134.435 63.8064 135.012 68.1672C135.748 73.5787 140.687 77.414 146.151 76.7836L151.195 76.2057",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.885 67.5366C147.885 67.5366 143.104 67.2739 141.527 63.8588",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M227.322 216.432V179.707",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M173.996 64.0164C174.258 66.3807 175.467 68.2196 176.728 68.0619C177.989 67.9043 178.777 65.9078 178.514 63.491C178.251 61.1268 177.043 59.2879 175.782 59.4455C174.521 59.6031 173.733 61.6522 173.996 64.0164Z",
    fill: "#0A0A0A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M194.643 61.7574C194.906 64.1217 196.114 65.9605 197.375 65.8029C198.636 65.6453 199.424 63.6488 199.162 61.232C198.899 58.8677 197.691 57.0289 196.43 57.1865C195.221 57.3441 194.433 59.3931 194.643 61.7574Z",
    fill: "#0A0A0A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M201.421 49.253C201.421 49.253 198.689 46.3108 191.648 48.3598",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M180.668 50.7765C180.668 50.7765 171.053 49.2003 165.957 55.4525",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M188.023 60.3386C188.233 63.8587 189.756 66.906 191.333 70.0058C191.7 70.6888 192.016 71.3718 192.173 72.1599C192.331 72.7378 192.278 73.2632 192.121 73.7361C191.805 74.7869 190.86 75.575 189.809 75.8902C188.18 76.4156 188.863 78.9375 190.492 78.4121C192.016 77.9392 193.434 76.941 194.222 75.4699C195.01 73.9462 195.01 72.265 194.485 70.6363C193.854 68.85 192.751 67.2213 192.016 65.4349C191.28 63.8062 190.755 62.0724 190.65 60.2861C190.544 58.6574 187.918 58.6574 188.023 60.3386Z",
    fill: "#0A0A0A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M178.882 85.9252C179.933 88.4996 181.772 90.6537 184.346 91.8096C186.92 92.9655 189.81 93.0705 192.49 92.0723C193.173 91.8096 193.593 91.1791 193.383 90.4436C193.225 89.8131 192.437 89.2877 191.754 89.5504C189.705 90.286 187.551 90.3385 185.554 89.4979C183.715 88.7098 182.139 87.1336 181.351 85.2422C181.089 84.5592 180.458 84.1389 179.723 84.3491C179.197 84.5067 178.619 85.2948 178.882 85.9252Z",
    fill: "#0A0A0A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M217.077 267.921L201.63 265.977L189.967 261.879",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M211.298 274.278L195.011 273.595L188.969 272.386",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M204.889 281.055L187.184 279.952",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M360.121 321.178C398.305 282.995 398.305 221.088 360.121 182.905C321.938 144.722 260.031 144.722 221.848 182.905C183.665 221.088 183.665 282.995 221.848 321.178C260.031 359.362 321.938 359.362 360.121 321.178Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M360.121 321.178C398.305 282.995 398.305 221.088 360.121 182.905C321.938 144.722 260.031 144.722 221.848 182.905C183.665 221.088 183.665 282.995 221.848 321.178C260.031 359.362 321.938 359.362 360.121 321.178Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2172 173.31C114.012 170.651 124.66 155.692 122.001 139.897C119.343 124.103 104.383 113.454 88.5887 116.113C72.7942 118.772 62.1457 133.731 64.8045 149.526C67.4633 165.32 82.4227 175.969 98.2172 173.31Z",
    fill: "#FF5D0E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M116.728 162.054L89.775 214.226L39.2324 188.114L65.7121 135.732L116.728 162.054Z",
    fill: "#FF5D0E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7755 214.226L82.7878 227.886L166.85 246.537C170.738 247.378 174.836 246.537 178.041 244.225L179.302 243.28C181.929 241.388 185.239 240.6 188.444 241.231L193.75 242.229L193.593 251.161L204.783 258.043L217.025 260.197C218.969 260.513 220.755 261.563 221.964 263.087C223.435 265.031 223.855 267.448 217.078 267.921C217.078 267.921 218.181 275.171 211.298 274.33C211.298 274.33 213.452 281.686 204.889 281.055C204.889 281.055 204.994 286.73 201.263 286.099L181.876 286.152L161.964 277.693L61.2993 271.336C32.2978 269.497 14.4345 238.761 27.2015 212.649L39.2329 188.114L89.7755 214.226Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7755 214.226L82.7878 227.886L166.85 246.537C170.738 247.378 174.836 246.537 178.041 244.225L179.302 243.28C181.929 241.388 185.239 240.6 188.444 241.231L193.75 242.229L193.593 251.161L204.783 258.043L217.025 260.197C218.969 260.513 220.755 261.563 221.964 263.087C223.435 265.031 223.855 267.448 217.078 267.921C217.078 267.921 218.181 275.171 211.298 274.33C211.298 274.33 213.452 281.686 204.889 281.055C204.889 281.055 204.994 286.73 201.263 286.099L181.876 286.152L161.964 277.693L61.2993 271.336C32.2978 269.497 14.4345 238.761 27.2015 212.649L39.2329 188.114L89.7755 214.226Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1467 229.094L73.4883 225.732",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1465 217.483L102.647 189.375",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6016 189.375L44.9062 176.818",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M341.228 168.832C341.228 168.832 336.079 176.292 335.554 180.18C334.976 184.331 337.918 188.797 343.014 186.065C343.014 186.065 342.752 195.627 351.315 192.054C351.315 192.054 350.632 200.355 359.039 196.94C359.039 196.94 359.669 204.086 365.711 200.828C370.387 198.306 375.326 184.961 377.06 178.499C378.058 174.769 374.38 169.935 370.545 170.145C370.44 170.145 370.335 170.145 370.229 170.145C370.229 170.145 368.233 165.417 363.294 165.627C363.294 165.627 360.405 160.531 355.413 161.687C355.413 161.687 353.102 156.958 348.478 157.956C343.907 158.954 334.24 164.996 334.24 164.996L341.228 168.832Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M341.228 168.832C341.228 168.832 336.079 176.292 335.554 180.18C334.976 184.331 337.918 188.797 343.014 186.065C343.014 186.065 342.752 195.627 351.315 192.054C351.315 192.054 350.632 200.355 359.039 196.94C359.039 196.94 359.669 204.086 365.711 200.828C370.387 198.306 375.326 184.961 377.06 178.499C378.058 174.769 374.38 169.935 370.545 170.145C370.44 170.145 370.335 170.145 370.229 170.145C370.229 170.145 368.233 165.417 363.294 165.627C363.294 165.627 360.405 160.531 355.413 161.687C355.413 161.687 353.102 156.958 348.478 157.956C343.907 158.954 334.24 164.996 334.24 164.996L341.228 168.832Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M343.014 186.012C343.014 186.012 351.525 177.291 354.94 165.575",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M351.211 191.897C351.211 191.897 359.722 183.175 363.137 171.459",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M359.145 196.52C359.145 196.52 367.183 187.483 370.598 175.767",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M184.24 103.999V105.26",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M304.703 122.438L309.941 127.676L315.18 122.438L309.941 117.2L304.703 122.438Z",
    fill: "#FF5D0E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M461.179 138.784L469.018 146.622L476.856 138.784L469.018 130.945L461.179 138.784Z",
    fill: "#FF5D0E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M399.297 31.1705L411.631 43.5045L423.965 31.1705L411.631 18.8366L399.297 31.1705Z",
    fill: "#FF5D0E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M331.14 237.395C329.774 225.994 320.159 217.115 308.706 216.642C301.718 216.38 295.413 219.112 290.948 223.683C286.692 219.322 280.755 216.59 274.135 216.59C261.105 216.59 250.598 227.15 250.598 240.127C250.598 246.485 253.855 251.581 257.165 256.414C262.787 264.558 279.914 280.215 287.322 286.835C289.319 288.621 292.314 288.568 294.258 286.782C301.981 279.794 320.422 262.772 326.674 253.998C330.037 249.479 331.928 243.7 331.14 237.395Z",
    fill: "#FF5D0E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M459.494 374.891L491.753 281.581C493.592 276.222 489.651 270.653 483.977 270.653H353.733C352.156 270.653 350.79 271.651 350.318 273.122L316.325 379.829H229.11C227.481 379.829 226.115 381.143 226.115 382.824C226.115 384.453 227.429 385.819 229.11 385.819H444.257C451.088 385.766 457.235 381.405 459.494 374.891Z",
    fill: "#0A0A0A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M316.745 378.463L350.212 273.07C350.685 271.651 351.999 270.653 353.522 270.653C355.887 270.653 357.568 272.965 356.832 275.224L322.051 382.246C321.368 384.347 319.372 385.819 317.165 385.819H229.057C227.429 385.819 226.062 384.505 226.062 382.824C226.062 381.195 227.376 379.829 229.057 379.829H314.801C315.694 379.829 316.482 379.251 316.745 378.463Z",
    fill: "#9F99AA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M229.057 385.766C227.429 385.766 226.062 384.452 226.062 382.771C226.062 381.142 227.376 379.776 229.057 379.776H314.801C315.694 379.776 316.43 379.198 316.692 378.41L350.16 273.017C350.633 271.598 351.946 270.6 353.47 270.6",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M406.166 332.176L412.891 344.786L425.028 332.176L417.409 319.252L406.166 332.176Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77344 385.766H522.225",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M470.632 252.422H409.529C403.96 252.422 399.441 247.903 399.441 242.334V198.096L433.329 167.413C437.164 163.946 443.049 163.946 446.884 167.413L480.772 198.096V242.334C480.719 247.903 476.201 252.422 470.632 252.422Z",
    fill: "#FF5D0E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M470.632 252.422H409.529C403.96 252.422 399.441 247.903 399.441 242.334V198.096L433.329 167.413C437.164 163.946 443.049 163.946 446.884 167.413L480.772 198.096V242.334C480.719 247.903 476.201 252.422 470.632 252.422Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M399.441 198.096L477.935 249.322",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M480.72 198.096L402.227 249.322",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M462.121 177.659H417.935C414.1 177.659 411 180.758 411 184.594V205.609L440.002 224.628L469.003 205.609V184.594C469.003 180.758 465.903 177.659 462.121 177.659Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M462.121 177.659H417.935C414.1 177.659 411 180.758 411 184.594V205.609L440.002 224.628L469.003 205.609V184.594C469.003 180.758 465.903 177.659 462.121 177.659Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M424.029 196.467H456.078",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M424.029 206.818H456.078",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M406.94 104.017C408.114 99.8559 405.693 95.5309 401.532 94.3567C397.372 93.1824 393.047 95.6036 391.872 99.7645C390.698 103.925 393.119 108.25 397.28 109.425C401.441 110.599 405.766 108.178 406.94 104.017Z",
    fill: "#FF5D0E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M386.623 126.17C386.623 119.077 392.35 113.351 399.443 113.351C406.535 113.351 412.262 119.077 412.262 126.17",
    stroke: "#FF5D0E",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M417.883 138.307H380.896C375.537 138.307 371.229 133.946 371.229 128.64V91.6521C371.229 86.2931 375.589 81.9849 380.896 81.9849H417.883C423.242 81.9849 427.55 86.3457 427.55 91.6521V128.64C427.603 133.999 423.242 138.307 417.883 138.307Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.62695,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M258.479 81.6171C248.287 73.1583 241.824 60.4439 241.824 46.2058C241.824 20.8294 262.42 0.234131 287.796 0.234131C313.172 0.234131 333.768 20.8294 333.768 46.2058C333.768 71.5822 313.172 92.1775 287.796 92.1775C282.017 92.1775 276.447 91.1267 271.351 89.1302C256.01 100.952 244.241 97.6941 244.241 97.6941C251.596 92.4402 256.01 86.2406 258.479 81.6171Z",
    fill: "#0A0A0A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M270.282 46.3755C270.602 42.9374 268.074 39.8909 264.636 39.571C261.198 39.251 258.151 41.7787 257.831 45.2169C257.511 48.655 260.039 51.7015 263.477 52.0215C266.915 52.3414 269.962 49.8137 270.282 46.3755Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M294.062 46.0149C294.184 42.5641 291.486 39.6674 288.035 39.545C284.584 39.4226 281.688 42.121 281.565 45.5719C281.443 49.0228 284.141 51.9194 287.592 52.0418C291.043 52.1641 293.94 49.4658 294.062 46.0149Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M317.796 46.2115C318.012 42.7655 315.393 39.7969 311.947 39.5811C308.501 39.3653 305.532 41.984 305.317 45.4301C305.101 48.8761 307.719 51.8446 311.165 52.0604C314.611 52.2762 317.58 49.6576 317.796 46.2115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/loginImage.82024648cb4a59a530a8bf23c3cc600d.svg";
export { ForwardRef as ReactComponent };